import { render, staticRenderFns } from "./VirtualDesktopTrafficDetail.vue?vue&type=template&id=110073b8&scoped=true"
import script from "./VirtualDesktopTrafficDetail.vue?vue&type=script&lang=ts"
export * from "./VirtualDesktopTrafficDetail.vue?vue&type=script&lang=ts"
import style0 from "./VirtualDesktopTrafficDetail.vue?vue&type=style&index=0&id=110073b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110073b8",
  null
  
)

export default component.exports